import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import WatchButton from '../../WatchButton';
import Button from '../Button';
import Plus from '../../Icons/Plus';
import { IconSize } from '../../Icons/IconWrap';
import Check from '../../Icons/Check';
import { BiDataHook } from '../../biLogger';
import s from './ProfileOwnerWatchButton.scss';
var ProfileOwnerWatchButton = function (props) {
    var user = props.user, initialData = props.initialData;
    return (React.createElement(WatchButton, { user: user, initialData: initialData }, function (watchProps) { return (React.createElement(ProfileOwnerWatchButtonContent, __assign({}, props, watchProps))); }));
};
ProfileOwnerWatchButton.displayName = 'ProfileOwnerWatchButton';
var ProfileOwnerWatchButtonContent = /** @class */ (function (_super) {
    __extends(ProfileOwnerWatchButtonContent, _super);
    function ProfileOwnerWatchButtonContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isNewWatching: false,
        };
        _this.handleClick = function () {
            _this.setState({ isNewWatching: !_this.props.isWatching });
            _this.props.onClick();
        };
        _this.handleMouseLeave = function (e) {
            // added if case, because when you click on button's child elements , the mouselive event triggers
            if (e.currentTarget !== e.target) {
                return;
            }
            _this.setState({ isNewWatching: false });
        };
        return _this;
    }
    ProfileOwnerWatchButtonContent.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, height = _a.height, text = _a.text, isWatching = _a.isWatching, className = _a.className, isLoading = _a.isLoading, biData = _a.biData, view = _a.view;
        var isNewWatching = this.state.isNewWatching;
        var defaultWatchigState = !isLoading && isWatching;
        var loadingWatchingState = isLoading && !isWatching;
        var loadingUnwatchingState = isLoading && isWatching;
        return (React.createElement(Button, { view: view ? view : 'b1', biData: biData, height: height, className: classnames(s['root'], defaultWatchigState && !isNewWatching && s['watch-btn-unwatch'], defaultWatchigState && s['watch-btn-watching'], loadingUnwatchingState && s['watch-btn-loading-unwatch'], loadingWatchingState && s['watch-btn-loading'], className), onClick: this.handleClick, onMouseLeave: this.handleMouseLeave, disabled: disabled, dataHook: BiDataHook.USER_WATCH_BUTTON },
            React.createElement(Plus, { customSizable: true, className: classnames(s['plus-icon']), size: IconSize.SMALL }),
            isWatching && !isLoading && (React.createElement(Check, { customSizable: true, className: classnames(s['check-icon']), size: IconSize.SMALL })),
            React.createElement("span", { className: classnames((defaultWatchigState || loadingWatchingState) && s['watch-btn-text']) }, text)));
    };
    ProfileOwnerWatchButtonContent.defaultProps = {
        height: 'medium',
    };
    return ProfileOwnerWatchButtonContent;
}(React.Component));
export default ProfileOwnerWatchButton;
//# sourceMappingURL=ProfileOwnerWatchButton.js.map